import { logFeature } from '@office-start/telemetry-service';
/**
 * Used to log event related to content URL dialogs leveraging task module dialog
 * @param debugInfo Information to aid with debugging issue
 */
export const logTaskModuleDialogDebugEvent = (debugInfo) => {
    logFeature({
        featureName: "MOSHub" /* KnownFeatureNames.MOSHub */,
        eventName: "MOS_Task_Module_Dialog" /* KnownFeatureInstrumentationEvents.MOSTaskModuleDialog */,
        area: 'MOSAppHost',
        params: { DebugInfo: debugInfo },
        subArea: 'MOSTaskModuleDialog',
    });
};
//# sourceMappingURL=logTaskModuleDialogDebugEvent.js.map